import jiajiang from "./index.vue";
import jiajiangHome from "./Home.vue";

const gasClamp = () => import("./gasClamp.vue");
const steelBoxGirder = () => import("./steelBoxGirder.vue");
const saddleRoom = () => import("./saddleRoom.vue");
// const airProJY = () => import('./airProJY.vue')
// const airProPK = () => import('./airProPK.vue')
const airProcNew = () => import("./airProcNew.vue");
const anchorRoomJY = () => import("./anchorRoomJY.vue");
const anchorRoomPK = () => import("./anchorRoomPK.vue");
const socketRecord = () => import("./socketRecord.vue");

const dataHistory = () => import("./../../components/DataHistory.vue");
const bridgeImg = () => import("./bridgeImg.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/jiajiangIndex",
    name: "jiajiangIndex",
    component: jiajiangHome,
  },
  {
    path: "/jiajiang/login",
    name: "jiajiangLogin",
    component: login,
  },
  {
    path: "/jiajiang",
    name: "jiajiang",
    redirect: "/jiajiang/saddleRoom",
    component: jiajiang,
    children: [
      {
        path: "socketRecord",
        name: "jjSocketRecord",
        component: socketRecord,
      },
      {
        path: "gasClamp",
        name: "jjGasClamp",
        component: gasClamp,
      },
      {
        path: "steelBoxGirder",
        name: "jjSteelBoxGirder",
        component: steelBoxGirder,
      },
      {
        path: "saddleRoom",
        name: "jjSaddleRoom",
        component: saddleRoom,
      },
      {
        path: "airProJY",
        name: "jjAirProJY",
        component: airProcNew,
      },
      {
        path: "airProPK",
        name: "jjAirProPK",
        component: airProcNew,
      },
      {
        path: "anchorRoomJY",
        name: "jjAnchorRoomJY",
        component: anchorRoomJY,
      },
      {
        path: "anchorRoomPK",
        name: "jjAnchorRoomPK",
        component: anchorRoomPK,
      },
      {
        path: "dataHistory",
        name: "jjDataHistory",
        component: dataHistory,
      },
      {
        path: "bridgeImg",
        name: "jjBridgeImg",
        component: bridgeImg,
      },
    ],
  },
];
